


















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Number from "@/shared/filters/Number";
import { Getter, Action } from "vuex-class";

import { CarSelectData } from "@/model/CarSelection";
import { CarSelectQuickInfoData } from "@/model/CarSelectionQuickInfo";
import { CarSelectQuickInfoCustomerData } from "@/model/CarSelectionQuickInfoCustomer";

import requestService from "@/service/requestService";
import { Utils } from "@/service/util";


@Component({
  components: {
  },
  filters: {
    Number
  }
})
export default class MainQuick extends Vue {
  @Prop({ default: true })
  isShowNyuukoRireki: boolean;

  isUserMode = false;
  activePage: number = 1;
  info: any = {
    customerName: "上",
    soukou: 10000,
    soukouUnitKbn: 1,
    modelNm: "軽自動車",
    nyuukoRireki: "なし",
    nenshiki: "13年未満",
    torokubango: "5945",
    frontStaff: "平井 康博",
    fTire: "195/55/R15 ｲﾝﾁ",
    rTire: "195/55/R15 ｲﾝﾁ"
  };

  nenshikiItems: any = [
    {
      nenshikiCd: "1",
      nenshikiNm: "13年未満車",
    },
    {
      nenshikiCd: "2",
      nenshikiNm: "13年～18年未満車",
    },
    {
      nenshikiCd: "3",
      nenshikiNm: "18年経過車",
    }
  ];

  carForm: any = {};
  carFormQuickInfo: any = {};
  customerInfo: any = {};
  kbnJidousha: any = [];
  staffs: any = [];
  selectTabNum: number = 0;

  // imgSrc: any = "https://work.extreme-service.jp/inspect_img/cus/1/79000115-63b4-41b8-a729-57820bf19a29.jpg";
  imgSrc: any = "https://work.extreme-service.jp/qr/img/100000/1000000000";

  option: any = {
    errorCorrectionLevel: "M",
    maskPattern: 0,
    margin: 0,
    scale: 2,
    width: 120,
    color: {
      dark: "#000000FF",
      light: "#FFFFFFFF"
    }
  };

  public reqService: requestService = new requestService();
  public utils: Utils = new Utils();

  @Getter("currentState", { namespace: "CarSelection" })
  currentState: CarSelectData;

  @Getter("currentState", { namespace: "CarSelectionQuickInfo" })
  currentStateQuickInfo: CarSelectQuickInfoData;

  @Getter("currentState", { namespace: "CarSelectionQuickInfoCustomer" })
  currentStateQuickInfoCustomer: CarSelectQuickInfoCustomerData;

  @Action("setState", { namespace: "NavigationsQM" })
  setStateNavigationsQM: any;

  @Getter("hasData", { namespace: "Shohiyou" })
  hasCostData: boolean;

  created() {
    this.reqService.getKbnSkns("skn_jidousha_shubetsu", "7101").then(
      (res: any) => {
        if (res) {
          this.$set(this, "kbnJidousha", res);
        }
      },
      (err: any) => {}
    );
    this.reqService.getStaffFront().then(
      (res: any) => {
        if (res) {
          this.staffs = res;
        }
      },
      (err: any) => {
        this.staffs = [];
      }
    );

    this.carForm = this.currentState;
    this.carFormQuickInfo = this.currentStateQuickInfo;
    this.customerInfo = this.currentStateQuickInfoCustomer;
  }

  get customerName() {
    if (!this.customerInfo) {
      return '上';
    }
    if (!this.customerInfo.kojinNmKjSei && !this.customerInfo.kojinNmKjMei) {
      return '上';
    }
    return this.customerInfo.kojinNmKjSei + '　' + this.customerInfo.kojinNmKjMei;
  }

  get jidoushaShubetsuName() {

    let obj = this.kbnJidousha.filter((item: any) => +item.kbnKey === +this.carForm.jidoushaShubetsu);

    if (obj && obj.length > 0) {
      return obj[0].value;
    }

    return "未選択";
  }

  get tourokuBangou() {

    if (!this.carFormQuickInfo) {
      return '-';
    }

    return this.carFormQuickInfo.srPlateAreaNm
    + " " + this.carFormQuickInfo.srPlateModelNm
    + " " + this.carFormQuickInfo.srPlateKanaNm
    + " " + this.carFormQuickInfo.srPlateNo;
  }

  get keikaShareki() {
    let nenshikiObj = this.nenshikiItems.filter((item: any) => item.nenshikiCd === this.carFormQuickInfo.keikaShareki);

    if (nenshikiObj && nenshikiObj.length > 0) {
      return nenshikiObj[0].nenshikiNm;
    }

    return "未選択";
  }

  get soukou() {
    let soukou = this.carForm.soukouUnitKbn == 1 ? this.carForm.soukouKm : this.carForm.soukouMile;
    return !soukou ? '-' : soukou;
  }

  get soukouUnitKbn() {
    return this.carForm.soukouUnitKbn == 1 ? "km" : "ﾏｲﾙ";
  }

  get frontTantousha() {
    let frontStaff = this.staffs.filter((item: any) => item.staffCd === this.carFormQuickInfo.frontTantoushaCd);
    return frontStaff && frontStaff.length > 0 ? frontStaff[0].staffNm : '-';
  }

  get fTireSizeInput() {
    if (this.carForm.fTireSizeInput) {
      return this.carForm.fTireSizeInput;
    }
    return '';
  }

  get rTireSizeInput() {
    if (this.carForm.rTireSizeInput) {
      return this.carForm.rTireSizeInput;
    }
    return '';
  }

  get hasVehicleName() {
    if (this.customerInfo.vehicleNm) {
      return true;
    }
    return false;
  }

  get vehicleName() {
    return this.customerInfo.vehicleNm;
  }

  /** 2021-10-11 sh #7458 change layout at quick mitsumori. [START] */
  get mitsumoriDate() {
    let today = new Date();
    return today.getFullYear() + "/" +  (+today.getMonth() + 1) + "/"+ today.getDate();
  }
  /** 2021-10-11 sh #7458 change layout at quick mitsumori. [END] */

  /** 2021-11-03 sh #7521 it has script error, when open. [START] */
  get IsHoujin() {
    if (this.customerInfo) {
      return (this.customerInfo.kkKbn && this.customerInfo.kkKbn == 2);
    }
    return false;
  }
  /** 2021-11-03 sh #7521 it has script error, when open. [END] */
}
